import { render } from "./SubHeader.vue?vue&type=template&id=6915b796&ts=true&lang=pug"
import script from "./SubHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubHeader.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__